import { render, staticRenderFns } from "./ResumenDiario.vue?vue&type=template&id=880866d4&scoped=true&"
import script from "./ResumenDiario.vue?vue&type=script&lang=js&"
export * from "./ResumenDiario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880866d4",
  null
  
)

export default component.exports